import { render, staticRenderFns } from "./ProductSatisfactionSurveyList.vue?vue&type=template&id=47d1dd2e&scoped=true&"
import script from "./ProductSatisfactionSurveyList.vue?vue&type=script&lang=js&"
export * from "./ProductSatisfactionSurveyList.vue?vue&type=script&lang=js&"
import style0 from "./ProductSatisfactionSurveyList.vue?vue&type=style&index=0&id=47d1dd2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d1dd2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d1dd2e')) {
      api.createRecord('47d1dd2e', component.options)
    } else {
      api.reload('47d1dd2e', component.options)
    }
    module.hot.accept("./ProductSatisfactionSurveyList.vue?vue&type=template&id=47d1dd2e&scoped=true&", function () {
      api.rerender('47d1dd2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/report/ProductSatisfactionSurveyList.vue"
export default component.exports